import React, { useMemo } from 'react'
import { IntlProvider as ReactIntlProvider, IntlConfig } from 'react-intl'
import useGetData from 'hooks/useGetData'
import _ from 'lodash'

function flattenDot (obj, acc = {}, path = '') {
  return _.transform(obj, (acc, val, key) => {
    if (_.isObject(val)) {
      flattenDot(val, acc, `${path}${String(key)}.`)
    } else {
      acc[path + String(key)] = val
    }
  }, acc)
}

type Props = IntlConfig & {
  lang: string
}

const IntlProvider: React.FC<Props> = ({
  children,
  lang,
  locale,
  messages,
}) => {
  const args = useMemo(() => ({
    language: lang,
  }), [lang])
  const {
    data,
  } : {
    data: any
  } = useGetData('Translations', args)

  const memoMessages = useMemo(() => {
    if (data) {
      return {
        ...messages,
        ...flattenDot(data.Translations)
      }
    }

    return messages
  }, [messages, data])


  return (
    <ReactIntlProvider
      locale={locale}
      messages={memoMessages}
    >
      {children}
    </ReactIntlProvider>
  )
}

export default IntlProvider
